<template>
  <div class="wrapper-content w-100" id="documentos-asociados-new-or-edit">
    <h1>{{title}}</h1>
    <div>
      <LmBreadcrumb v-if="showBreadcrumb" />
      <h4>{{form.subTitle}}</h4>
      <LmForm ref="lmFormRef">
        <div class="row">
          <div class="col-12 col-lg-12">
            <LmTextInput
              v-model="form.description"
              :v="$v.form.description"
              label="Nombre"
              placeholder="Nombre"
              />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <draggable
              tag="b-list-group"
              v-model="form.files"
              group="people"
              @start="drag=true"
              @end="drag=false"
              >
                <b-list-group-item
                  v-for="(file, index) in form.files"
                  :key="index"
                  class="d-flex justify-content-between"
                  >
                  <font-awesome-icon class="bar mr-2" icon="bars" />
                  <button
                    type="button"
                    v-b-modal.fileDetailModal
                    class="btn btn-link p-0  text-truncate text-left w-100"
                    @click="setAnexosModalFile(file)"
                    >{{file.originalname}}</button>
                  <div class="d-flex justify-content-end align-items-center">
                    <b-badge variant="primary file-size">{{ formatBytes(file.size) }}</b-badge>
                    <font-awesome-icon class="close ml-3" icon="times" @click="deleteUploadFile(index)"/>
                  </div>
                </b-list-group-item>
            </draggable>
          </div>
          <b-overlay
          :show="isDropzoneLoading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
          class="mb-3 col-12"
          >
            <LmUploadFiles
              ref="lmUploadFiles"
              :dropzoneOptions="dropzoneOptions"
              dictDefaultMessage='Arrastre el archivo para subirlo'
              @vdropzone-removed-file="fileRemoved"
              @vdropzone-success="fileCreated"
              @vdropzone-error="dropzoneErrorHandler"
              @vdropzone-file-added="isDropzoneLoading = true"
            />
          </b-overlay>
          <div
            class="mb-3 col-12"
            >
            <b-alert
              v-for="(dropzoneError, index) in dropzoneErrors"
              :key='index'
              :show="5"
              :variant="dropzoneError.variant"
              @dismissed="dropzoneErrors.splice(index, 1)"
              fade
              >{{dropzoneError.message}}</b-alert>
          </div>
        </div>

        <LmButton
          id="go-back-button"
          v-if="enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click.native="goBackBtn"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          />
        <LmButton
          id="cancel-button"
          v-if="!enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :isProcessing="formIsProcessing"
          :value="$t('Cancel')"
          @click.native="cancelBtn"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          />
        <LmButton
          id="btn-submit"
          type="submit"
          buttonClass="btn-primary"
          :isProcessing="formIsProcessing"
          :value="$t('Save')"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          @click.native="guardar"
          v-if="form.permiteGuardar"
        />
        <LmButton
          id="btn-borrar"
          type="submit"
          buttonClass="btn-danger"
          :isProcessing="formIsProcessing"
          :value="$t('delete')"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          @click.native="borrar"
          v-if="form.permiteGuardar && isOnEditMode"
        />
      </LmForm>
    </div>
    <b-modal id="fileDetailModal" :title="detailModalFile.name" size="xl" hide-footer >
      <iframe :src="detailModalFile.src" frameborder="0" style="height:75vh;" width="100%"></iframe>
    </b-modal>
    <lmConfirmationModal ref="lmConfirmationDeleteModal" title="Aviso" message="Esta eliminar el documento.  Está seguro?"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
import LmForm from '@/components/form/LmForm.vue'
import LmButton from '@/components/form/elements/LmButton'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmTextInput from '@/components/form/elements/LmTextInput'
import lmFormatBytes from '@/mixins/lmFormatBytes.js'
import draggable from 'vuedraggable'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'

export default {
  mixins: [lmFormatBytes],
  components: {
    LmForm,
    LmButton,
    LmUploadFiles,
    draggable,
    LmTextInput,
    lmConfirmationModal
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      dropzoneErrors: [],
      detailModalFile: {
        src: '',
        name: ''
      },
      isDropzoneLoading: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}${this.uploadEndpointUri}`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null
        },
        withCredentials: true,
        thumbnailWidth: 150,
        previewsContainer: false,
        addRemoveLinks: false
      },
      lmUploadFiles: [],
      form: {
        subTitle: 'Nuevo',
        permiteGuardar: true,
        description: '',
        files: []
      },
      initialForm: {},
      formIsProcessing: false
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    // La uri al endpoint que permite subir los archivos
    uploadEndpointUri: {
      type: String,
      required: true
    },
    // La uri para interactuar con el endpoint que obtiene y persiste los datos
    // para la edicion
    newEndpointUri: {
      type: String,
      required: true
    },
    editEndpointUri: {
      type: String,
      required: true
    },
    deleteEndpointUri: {
      type: String,
      required: false
    },
    isOnEditMode: {
      type: Boolean,
      required: true,
      default: false
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    },
    fileLimits: {
      type: Number,
      required: false,
      default: 40
    }
  },
  validations () {
    return {
      form: {
        description: {
          required
        },
        files: {
          required,
          maxLength: maxLength(this.fileLimits)
        }
      }
    }
  },
  watch: {
    '$route.path' () {
      this.setForm()
    },
    isOnEditMode () {
      this.setForm()
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    ...mapActions('session', ['getUserInfo']),
    setAnexosModalFile (file) {
      this.detailModalFile.src = process.env.VUE_APP_API_URL_STATIC_ASSETS + file.path
      this.detailModalFile.name = file.originalname
    },
    deleteUploadFile (index) {
      this.form.files.splice(index, 1)
      this.lmUploadFiles.splice(index, 1)
    },
    fileCreated (file, response) {
      if (response) {
        this.form.files.push(response)
        this.isDropzoneLoading = false
      }
    },
    fileRemoved (file, error, xhr) {
      if (file) {
        this.form.files = this.form.files.filter(f => f.name !== file.name)
        this.$forceUpdate()
      }
    },
    dropzoneErrorHandler (file) {
      const error = {
        variant: '',
        message: ''
      }
      if (file?.xhr?.status === 413) {
        const maxValueAllowedByServe = JSON.parse(file?.xhr?.response).message.match(/\d+/g)[0]
        error.message = `Lo sentimos, el tamaño del archivo "${file.name}" excede el tamaño máximo permitido ${this.formatBytes(maxValueAllowedByServe)}`
        error.variant = 'danger'
      } else {
        error.message = file?.xhr?.response ? JSON.parse(file?.xhr?.response).message : ''
        error.variant = 'danger'
      }
      this.$refs.lmUploadFiles.lmRemoveFile(file)
      this.dropzoneErrors.push(error)
    },
    async setForm () {
      if (this.isOnEditMode) {
        this.$refs.lmFormRef.activeEditMode({
          path: `${this.editEndpointUri}${this.$route.params.ntransac}/`,
          id: this.$route.params.id
        })
          .catch(error => {
            console.log(error)
            this.$router.replace({ name: '404' })
          })
      } else {
        this.form = JSON.parse(this.initialForm)
      }
    },
    goBackBtn () {
      this.$router.go(-1)
    },
    cancelBtn () {
      this.$router.go(-1)
      // if (this.isOnEditMode) {
      //   this.$router.push(`${this.onSuccessDestinationRoute}/${this.$route.params.ntransac}`)
      // } else {
      //   this.$router.push(`${this.onSuccessDestinationRoute}/${this.$route.params.id}`)
      // }
    },
    async guardar () {
      try {
        if (this.isOnEditMode) {
          this.formIsProcessing = true
          await this.$refs.lmFormRef.validationForm(this.$v)
          let updateAttributes = {
            id: this.$route.params.id,
            description: this.form.description,
            files: this.form.files
          }
          this.updateItemDetail({
            path: `${this.editEndpointUri}${this.$route.params.ntransac}/`,
            data: updateAttributes
          })
            .then(() => {
              this.formIsProcessing = false
              this.$router.push(`${this.onSuccessDestinationRoute}/${this.$route.params.ntransac}`)
            })
            .catch(e => {
              this.formIsProcessing = false
            })
        } else {
          this.formIsProcessing = true
          await this.$refs.lmFormRef.validationForm(this.$v)
          let insertAttributes = {
            id: this.$route.params.id,
            description: this.form.description,
            files: this.form.files
          }
          this.updateItemDetail({
            path: this.newEndpointUri,
            data: insertAttributes
          })
            .then(() => {
              this.formIsProcessing = false
              this.$router.push(`${this.onSuccessDestinationRoute}/${this.$route.params.id}`)
            })
            .catch(e => {
              this.formIsProcessing = false
            })
        }
      } catch (error) {
        console.log(error)
        this.formIsProcessing = false
      }
    },
    async borrar () {
      try {
        if (this.isOnEditMode && this.form.permiteGuardar) {
          this.formIsProcessing = true
          await this.$refs.lmConfirmationDeleteModal.lmShow()
          let updateAttributes = {
            id: this.$route.params.id
          }
          this.updateItemDetail({
            path: `${this.deleteEndpointUri}${this.$route.params.ntransac}/`,
            data: updateAttributes
          })
            .then(() => {
              this.formIsProcessing = false
              this.$router.push(`${this.onSuccessDestinationRoute}/${this.$route.params.ntransac}`)
            })
            .catch(e => {
              this.formIsProcessing = false
            })
        }
      } catch (error) {
        console.log(error)
        this.formIsProcessing = false
      }
    }
  },
  mounted () {
    if (this.isOnEditMode === false) {
      let insertAttributes = {
        id: this.$route.params.id,
        validate: true
      }
      this.updateItemDetail({
        path: this.newEndpointUri,
        data: insertAttributes
      })
        .then(r => {
          if (r?.subTitle) {
            this.form.subTitle = r.subTitle
          }
        })
        .catch(error => {
          console.log(error)
          this.$router.replace({ name: '401' })
        })
    } else {
      this.setForm()
    }
  }
}
</script>

<style lang="sass" scoped>
#documentos-asociados-new-or-edit
  .lm-collapse
    top: 35px
    right: 0
    z-index: 1
  .observaciones-button
    min-width: 163px
  .estado-decreto
    h2
      margin-bottom: 40px
    margin-top: 20px
    margin-bottom: 40px
  .collapsing
    transition: none
  .close
    cursor: pointer
    font-size: 20px
  .bar
    cursor: grab
    font-size: 20px
  .f-icon
    top: 3px
    position: relative
  .file-name
    width: 50%
    @media(min-width: $lg)
      width: 70%
  .file-size
    line-height: 1.5
  hr
    border-top: 2px solid !important
    margin-top: 50px !important
    margin-bottom: 20px !important
  h4, h5
    margin-bottom: 30px !important
</style>
